import { useEffect, useState } from 'react';

export function useParentHover(
  childRef: React.RefObject<HTMLElement | null>
): boolean {
  const [isParentHovered, setIsParentHovered] = useState(false);

  useEffect(() => {
    if (!childRef.current || !childRef.current.parentElement) return;

    const parent = childRef.current.parentElement;

    const handleMouseEnter = () => setIsParentHovered(true);
    const handleMouseLeave = () => setIsParentHovered(false);

    parent.addEventListener('mouseenter', handleMouseEnter);
    parent.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      parent.removeEventListener('mouseenter', handleMouseEnter);
      parent.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [childRef]);

  return isParentHovered;
}
